<template>
    <div>
        <section>
            <!-- Navigation Header -->
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')" 
                             sizes="(max-width: 479px) 100vw, 84.03125px"
                             loading="lazy" 
                             class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="questionId > 1 ? questionId-- : null" class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>{{ questionId }}</strong> of <strong>{{ totalQuestions }}</strong></div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / totalQuestions) * 100) }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Basic Information Questions -->
                <!-- Question: Medical Conditions -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Please tell us more about your medical condition(s)</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <textarea v-model="formData.medicalConditionsDetail" 
                                        class="text-field-43 w-input" 
                                        placeholder="Please describe your medical conditions..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question: Current Medical Conditions -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">Please identify all your current medical conditions</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <textarea v-model="formData.currentMedicalConditions" 
                                        class="text-field-43 w-input" 
                                        placeholder="List all current medical conditions..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question: Current Medications -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">Please list all your current medications including dosages</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <textarea v-model="formData.currentMedications" 
                                        class="text-field-43 w-input" 
                                        placeholder="List medications and dosages..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question: Allergies -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">Please list all of your known allergies</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestionToUser">
                                <textarea v-model="formData.allergies" 
                                        class="text-field-43 w-input" 
                                        placeholder="List any known allergies..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question: Sex at Birth -->
                <div class="question-container"  v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">What was your gender at birth?</div>
                        <div class="form-subs">This will help our doctors recommend the proper medications and dosages.
                        </div>
                        <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="handleSexSelection('Female')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Female</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="handleSexSelection('Male')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d81974f75b229e7b38302_Male.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Male</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- Conditional Question: Pregnancy -->
                <div class="question-container" v-if="questionId === 6 && formData.sex === 'Female'">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently pregnant, breastfeeding or planning to become pregnant?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePregnancySelection('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePregnancySelection('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Height and Weight -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your height and weight?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input class="text-field-44 height w-input" 
                                           v-model="formData.height.feet"
                                           placeholder="Feet" 
                                           type="number" 
                                           required>
                                    <input class="text-field-44 height w-input" 
                                           v-model="formData.height.inches"
                                           placeholder="Inches" 
                                           type="number" 
                                           required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input class="text-field-45 weight w-input" 
                                           v-model="formData.weight"
                                           placeholder="Weight in pounds" 
                                           type="number" 
                                           required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Primary Reason -->
                <div class="question-container" v-if="questionId === 8">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your primary reason for requesting glutathione/NAD?</div>
                        <div class="felix-form-block w-form">
                            <form>
                                <a v-for="reason in primaryReasons" 
                                   :key="reason"
                                   href="#" 
                                   @click.prevent="setPrimaryReason(reason)" 
                                   class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">{{ reason }}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Current Symptoms -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently experiencing any of the following?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="multi-choice-boxes-div">
                                    <label v-for="(symptom, index) in symptoms" :key="'male-' + index"
                                        class="w-checkbox checkbox-field-multibox">
                                        <div :class="[
                                            'w-checkbox-input',
                                            'w-checkbox-input--inputType-custom',
                                            'checkbox-13',
                                            { 'w--redirected-checked': formData.currentSymptoms.includes(symptom.label) }
                                        ]"></div>
                                        <input type="checkbox" :id="'checkbox-' + index" :name="'checkbox-' + index"
                                            :data-name="'Checkbox ' + index" v-model="formData.currentSymptoms"
                                            :value="symptom.label" style="opacity:0;position:absolute;z-index:-1">
                                        <img :src="require(`@/assets/images/${symptom.icon}`)" loading="lazy" alt=""
                                            class="image-384">
                                        <span class="checkbox-label-14-check w-form-label" :for="'checkbox-' + index">
                                            {{ symptom.label }}
                                            <span v-if="symptom.subLabel" class="text-span-178">({{ symptom.subLabel
                                                }})</span>
                                        </span>
                                    </label>

                                    <!-- Other Symptoms Text Input -->
                                    
                                </div>
                                <div v-if="formData.currentSymptoms.includes('Other')" class="other-symptoms-input">
                                        
                                        <textarea 
                                            v-model="formData.otherSymptoms"
                                            class="text-field-43 w-input"
                                            placeholder="Please describe your other symptoms..."
                                            required></textarea>
                                    </div>
                                <input type="submit"  class="form-button w-button"  value="Next ->" :disabled="isOtherSelected && !formData.otherSymptoms">
                            </form>
                        </div>
                    </div>
                </div>

                
                <!-- Previous Treatment -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">Have you ever received anti-aging treatment before with metformin, glutathione or NAD?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handlePreviousTreatment('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handlePreviousTreatment('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Conditional: Previous Treatment Details -->
                <div class="question-container" v-if="questionId === 11 && formData.previousTreatment === 'Yes'">
                    <div class="question-div-2">
                        <div class="text-block-513">Please tell us more about what you used, when this was used, and any side effects you experienced.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <textarea v-model="formData.previousTreatmentDetails" 
                                        class="text-field-43 w-input" 
                                        placeholder="Describe your previous treatment experience..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Additional Questions -->
                <div class="question-container" v-if="questionId === 12">
                    <div class="question-div-2">
                        <div class="text-block-513">Do you have a known history of chronic kidney disease (CKD) or liver cirrhosis?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleDisqualifyingCondition('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handleDisqualifyingCondition('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Cancer Treatment -->
                <div class="question-container" v-if="questionId === 13">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you currently undergoing treatment for cancer, including chemotherapy or radiation therapy?</div>
                        <div class="felix-form-block w-form">
                            <div class="div-block-1487">
                                <a href="#" @click.prevent="handleDisqualifyingCondition('Yes')" class="button-68 w-button">Yes</a>
                                <a href="#" @click.prevent="handleDisqualifyingCondition('No')" class="button-68 w-button">No</a>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Additional Information -->
                <div class="question-container" v-if="questionId === 14">
                    <div class="question-div-2">
                        <div class="text-block-513">Is there anything else you want your prescriber to know about your condition or health?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <textarea v-model="formData.additionalInformation" 
                                        class="text-field-43 w-input" 
                                        placeholder="Share any additional information..."
                                        required></textarea>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Consent Forms -->
                <div class="question-container" v-if="questionId === 15">
                    <div class="question-div-2">
                        <div class="text-block-513">Please review and accept the consent forms</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="handleSubmit">
                                <div class="consent-text">
                                    <!-- Informed Consent Statement -->
                                    <p>{{ consentText }}</p>
                                </div>
                                <label class="w-checkbox checkbox-field-15 w-clearfix">
                                    <input type="checkbox" 
                                           v-model="formData.consentAccepted"
                                           required
                                           class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label">I have read and accept the consent forms</span>
                                </label>
                                <input type="submit" class="form-button w-button" value="Submit">
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>

export default {
    name: 'AntiAgingQuestionnaire',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            questionId: 1,
            totalQuestions: 15,
            formData: {
                medicalConditionsDetail: '',
                currentMedicalConditions: '',
                currentMedications: '',
                allergies: '',
                sex: '',
                isPregnant: null,
                height: {
                    feet: '',
                    inches: ''
                },
                weight: '',
                primaryReason: '',
                currentSymptoms: [],
                otherSymptoms: '',
                previousTreatment: null,
                previousTreatmentDetails: '',
                hasKidneyOrLiverDisease: null,
                hasCancerTreatment: null,
                additionalInformation: '',
                consentAccepted: false
            },
            primaryReasons: [
                'General wellness',
                'Anti-Aging',
                'Antioxidant benefits',
                'Boost energy',
                'Brighten skin',
                'Detoxification',
                'Immune support',
                'Other'
            ],
            symptoms: [
                 { label: 'Fatigue or Low Energy', icon: 'icon_-low-Energy.svg' },
                 { label: 'Memory Issues', icon: 'icon_-Brain.svg' },
                 { label: 'Difficulty Concentrating', icon: 'meditation-icon.svg' },
                 { label: 'Depression or Anxiety', icon: 'icon_-Anxiety.svg' },
                 { label: 'Sleep Disorders', subLabel: 'difficulty falling or staying asleep', icon: 'icon_-Sleep.svg' },
                 { label: 'Chronic Pain', icon: 'icon_-Joint-Pain.svg' },
                 { label: 'Other', icon: 'other-icon.svg' }
            ],
            consentText: `The products referenced (Glutathione, metformin and/or NAD+) are intended solely for lifestyle enhancement and are not approved by the U.S. Food and Drug Administration (FDA). These products are not designed to diagnose, treat, cure, or prevent any disease. Individual results may vary.

You understand that this medication is legally prescribed but used off-label for health and wellness purposes. Your healthcare provider will review your treatment plan before finalizing it.

Potential side effects may include nausea, headaches, fatigue, abdominal cramping, flushing, dizziness, and injection site reactions. You agree to report any side effects to your healthcare provider.

Regular monitoring will be required to ensure treatment safety and effectiveness.`
        }
    },
    computed: {
        isOtherSelected() {
            return this.formData.currentSymptoms.includes('Other')
        },
        isFormValid() {
            // Add form validation logic here
            return true
        }
    },
    watch: {
        'formData.currentSymptoms'(newSymptoms) {
            // Clear other symptoms text if 'Other' is unselected
            if (!newSymptoms.includes('Other')) {
                this.formData.otherSymptoms = ''
            }
        },
        questionId() {
            // Scroll to top when question changes
            window.scrollTo(0, 0)
        }
    },
    mounted(){
        this.setHeightAndWeight();
    },
    methods: {
        setHeightAndWeight(){
            try{
                let temp = this.$store.getters.user;
                if(temp){
                    this.formData.weight = temp.weight;
                    const totalInches = parseInt(temp.height_inch) || 0
                    this.formData.height.feet = Math.floor(totalInches / 12)
                    this.formData.height.inches = totalInches % 12
                }
            }catch(error){
                console.log("unable to set height and weight")
            }
            
        },
        nextQuestionToUser(){
            let temp = this.$store.getters.user;
            if(temp.gender!=null || temp.gender!==''){
                this.handleSexSelection(temp.gender);
            }else{
                this.questionId++
            }
        },
        nextQuestion() {
            // Validate that if 'Other' is selected, the other symptoms field is filled
            if (this.isOtherSelected && !this.formData.otherSymptoms.trim()) {
                alert('Please specify your other symptoms')
                return
            }
            
            // Format the symptoms data for submission
            const formattedSymptoms = this.formData.currentSymptoms.map(symptom => {
                if (symptom === 'Other') {
                    return `Other: ${this.formData.otherSymptoms}`
                }
                return symptom
            })
            
            // Update the formData with formatted symptoms
            this.formData.formattedSymptoms = formattedSymptoms
            
            // Proceed to next question
            if (this.questionId < this.totalQuestions) {
                this.questionId++
            }
        },
        handleSexSelection(sex) {
            this.formData.sex = sex.trim()
            if (this.formData.sex === 'Male') {
                this.questionId = 7;
            } else {
                this.nextQuestion()
            }
            
        },
        handlePregnancySelection(answer) {
            this.formData.isPregnant = answer === 'Yes'
            if (answer === 'Yes') {
                // Disqualify if pregnant
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        setPrimaryReason(reason) {
            this.formData.primaryReason = reason
            this.nextQuestion()
        },
        handlePreviousTreatment(answer) {
            this.formData.previousTreatment = answer
            if (answer === 'No') {
                // Skip previous treatment details question
                this.questionId += 2
            } else {
                this.nextQuestion()
            }
        },
        handleDisqualifyingCondition(answer) {
            if (answer === 'Yes') {
                this.disqualify()
            } else {
                this.nextQuestion()
            }
        },
        disqualify() {
            // Handle disqualification - redirect to disqualification page
            this.$router.push('/sorry')
        },
        async handleSubmit() {
            if (!this.formData.consentAccepted) {
                alert('Please accept the consent form to continue');
                return;
            }

            try {
                const formattedData = {
                    formObj: {
                        consentsSigned: this.formData.consentAccepted,

                        // Format Q&A pairs with full questions and available options
                        Q1: "Please tell us more about your medical condition(s)",
                        A1: this.formData.medicalConditionsDetail || "None reported",

                        Q2: "Please identify all your current medical conditions",
                        A2: this.formData.currentMedicalConditions || "None reported",

                        Q3: "Please list all your current medications including dosages",
                        A3: this.formData.currentMedications || "None reported",

                        Q4: "Please list all of your known allergies",
                        A4: this.formData.allergies || "None reported",

                        Q5: "What was your gender at birth? Available Options: Male, Female",
                        A5: this.formData.sex,

                        Q6: "Are you currently pregnant, breastfeeding or planning to become pregnant? Available Options: Yes, No",
                        A6: this.formData.sex === 'Female' ? (this.formData.isPregnant ? 'Yes' : 'No') : 'N/A',

                        Q7: "What is your height and weight?",
                        A7: `Height: ${this.formData.height.feet}'${this.formData.height.inches}", Weight: ${this.formData.weight} lbs`,

                        Q8: `What is your primary reason for requesting glutathione/NAD? Available Options: ${this.primaryReasons.join(', ')}`,
                        A8: this.formData.primaryReason,

                        Q9: `Are you currently experiencing any of the following? Available Options: ${this.symptoms.map(s => s.label).join(', ')}`,
                        A9: this.formatSymptoms(),

                        Q10: "Have you ever received anti-aging treatment before with metformin, glutathione or NAD? Available Options: Yes, No",
                        A10: `${this.formData.previousTreatment}${this.formData.previousTreatmentDetails ? ': ' + this.formData.previousTreatmentDetails : ''}`,

                        Q11: "Please tell us more about what you used, when this was used, and any side effects you experienced.",
                        A11: this.formData.previousTreatment === 'Yes' ? this.formData.previousTreatmentDetails : "No previous treatment",

                        Q12: "Do you have a known history of chronic kidney disease (CKD) or liver cirrhosis? Available Options: Yes, No",
                        A12: this.formData.hasKidneyOrLiverDisease,

                        Q13: "Are you currently undergoing treatment for cancer, including chemotherapy or radiation therapy? Available Options: Yes, No",
                        A13: this.formData.hasCancerTreatment,

                        Q14: "Is there anything else you want your prescriber to know about your condition or health?",
                        A14: this.formData.additionalInformation || "None provided",

                        Q15: "Consent Form Acknowledgment",
                        A15: this.formData.consentAccepted ? "Patient has acknowledged and consented" : "Consent not provided"
                    },
                    patientInfo: {
                        sex: this.formData.sex,
                        height: `${this.formData.height.feet}'${this.formData.height.inches}"`,
                        weight: this.formData.weight,
                        primaryReason: this.formData.primaryReason,
                        currentMedications: this.formData.currentMedications,
                        allergies: this.formData.allergies
                    },
                    pharmacyId: "",
                    masterId: `visit_${Date.now()}`,
                    company: "newSelf",
                    visitType: "anti-aging"
                };

                const response = await this.$axios.post(
                    `${this.baseUrl}/forms/assessment-form/anti-aging/${this.$route.params.id}`, 
                    formattedData
                );

                if (response.data.status === 'success') {
                    this.$router.push('/success');
                } else {
                    throw new Error('Form submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
                alert('There was an error submitting your form. Please try again.');
            }
        },

        // Helper method to format symptoms
        formatSymptoms() {
            if (!this.formData.currentSymptoms || this.formData.currentSymptoms.length === 0) {
                return "None reported";
            }

            return this.formData.currentSymptoms.map(symptom => {
                if (symptom === 'Other') {
                    return `Other: ${this.formData.otherSymptoms}`;
                }
                return symptom;
            }).join('; ');
        },

        // Add validation methods
        validateForm() {
            // Basic validation
            if (!this.formData.sex) {
                throw new Error('Gender is required');
            }
            
            // Height validation
            if (!this.validateHeight()) {
                throw new Error('Please enter a valid height');
            }
            
            // Weight validation
            if (!this.validateWeight()) {
                throw new Error('Please enter a valid weight');
            }
            
            // Symptom validation
            if (this.formData.currentSymptoms.includes('Other') && !this.formData.otherSymptoms) {
                throw new Error('Please specify your other symptoms');
            }
            
            return true;
        },
        validateHeight() {
            const feet = parseInt(this.formData.height.feet)
            const inches = parseInt(this.formData.height.inches)
            return feet >= 4 && feet <= 8 && inches >= 0 && inches <= 11
        },
        validateWeight() {
            const weight = parseInt(this.formData.weight)
            return weight >= 50 && weight <= 500
        },
        
    },
    

}
</script>

<style scoped>
textarea.w-input, textarea.w-select {
    height: auto;
    width: 100%;
}

.multi-choice-boxes-div {
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
}

.checkbox-field-multibox {
    border: 1px solid #000;
    border-radius: 9px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 48%;
    height: 160px;
    padding: 19px 13px;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
}

.checkbox-13-check {
    border: 1px #000;
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-left: 0;
    position: absolute;
    inset: 0%;
}

.image-384 {
    width: 55px;
    height: 55px;
    margin-bottom: 10px;
    position: relative;
}

.checkbox-label-14-check {
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    margin-top: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    position: relative;
}

.w-checkbox:after {
    content: " ";
    clear: both;
    grid-area: 1 / 1 / 2 / 2;
    display: table;
}

/* Add mobile responsiveness */
@media screen and (max-width: 479px) {
    .checkbox-field-multibox {
        width: 100%;
        margin-bottom: 10px;
    }
}
</style>